// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".variant-overview__brand-title[data-v-2370bba9]{display:none}@media screen and (min-width:960px){.variant-overview__brand-title[data-v-2370bba9]{display:block}}.buy-button.buy-button.buy-button[data-v-2370bba9]{min-width:144px}.product-price[data-v-2370bba9]{font-size:32px;font-weight:800}.delivery-meta-data[data-v-2370bba9]{background:var(--v-gray-lighten3);border-top:1px solid var(--v-gray-lighten2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
